import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HoomvipStorage} from '../hoomvip-storage/hoomvip-storage.service';
import {Observable, throwError} from 'rxjs';
import {HowWorks} from '../../shared/models/how-works.model';
import {ApiConfigService} from './api.config.service';
import {HTTP_CACHE_TTL_MS, HttpCacheService} from '../services/http-cache.service';

@Injectable({providedIn: 'root'})
export class HowWorksService {
  constructor(private http: HttpClient, private hoomvipStorage: HoomvipStorage, private apiConfigService: ApiConfigService, private cache: HttpCacheService) {
  }

  getHowWorks(): Observable<HowWorks> {
    const apartmentId = this.hoomvipStorage.getApartment();
    if (apartmentId === null) {
      return throwError(() => new Error('Apartment ID is required'));
    }
    const url = this.apiConfigService.getHowWorksUrl(apartmentId);
    const key = `HowWorksService:GET:${url}`;

    return this.cache.getOrSet<HowWorks>(
      key,
      HTTP_CACHE_TTL_MS.UNIMPORTANT,
      () => this.http.get<HowWorks>(url)
    );
  }
}
